import { Open } from './components'

export function CardCustomerService(props) {

  const { type, customerService, onClose } = props;

  return (
    <>
      {type === 'Open'
        &&
        <Open
          customerService={customerService}
          onClose={onClose}
        />
      }
    </>
  );
}